export default function promiseAnyWaitAll(promises) {
    let anyResolved = false;
    return Promise.all(promises.map((promise) => promise
        .then((result) => {
        anyResolved = true;
        return result;
    })
        .catch((error) => error))).then((result) => (anyResolved ? result : Promise.reject(result)));
}
//# sourceMappingURL=promise-any-wait-all.js.map